import Resource from './Resource';
class AIEmbedding extends Resource {
	constructor() {
		super('ai/embeddings');
	}

	similarSummaryCompanies(
		prospectingIds: string[],
		countryCode: string,
		limitResults: number = 50,
		threshold: number | null = 0.6,
		excludeExistingClients: boolean = true,
		headquarters: boolean | null = true,
		excludeExistingGroupMotherOrgnumbers: boolean = true
	) {
		// The threshold filters the results and sets a minimum cosine similarity = best match cosine similarity * threshold
		// e.g. if the best match has a cosine similarity of 0.95 and the threshold is 0.85, then all companies with
		// a cosine similarity of 0.8075 (0.95 * 0.85) or higher will be returned.
		// If threshold is null, no such filtering is done.
		return this._postRequest('similarSummaryCompanies', {
			prospectingIds,
			countryCode,
			limitResults,
			threshold,
			excludeExistingClients,
			headquarters,
			excludeExistingGroupMotherOrgnumbers
		}).then(res => res.data);
	}

	matchSummaryCompanies(
		freeText: string,
		countryCode: string,
		limitResults: number = 50,
		threshold: number | null = 0.7,
		excludeExistingClients: boolean = false,
		headquarters: boolean | null = true,
		excludeExistingGroupMotherOrgnumbers: boolean = false
	) {
		// The threshold filters the results and sets a minimum cosine similarity = best match cosine similarity * threshold
		// e.g. if the best match has a cosine similarity of 0.95 and the threshold is 0.85, then all companies with
		// a cosine similarity of 0.8075 (0.95 * 0.85) or higher will be returned.
		// If threshold is null, no such filtering is done.
		return this._postRequest('matchSummaryCompanies', {
			freeText,
			countryCode,
			limitResults,
			threshold,
			excludeExistingClients,
			headquarters,
			excludeExistingGroupMotherOrgnumbers
		}).then(res => res.data);
	}
}

export default new AIEmbedding();
